export const INIT_ROTATION_ANGLE = 0

export const ROTATION_ANGLE_PER_STEP = 90

export const MAX_ROTATION_ANGLE = 360

export const MAX_AVATAR_FILE_SIZE_MB = 16

export const MAX_AVATAR_FILE_SIZE_BYTE = MAX_AVATAR_FILE_SIZE_MB * 1024 * 1024

export const MIN_AVATAR_RESOLUTION = 30

export const ALLOWED_AVATAR_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'image/webp',
] as const

export const AVATAR_ERROR_TYPE = {
  unsupportedFormat: 'unsupportedFormat',
  tooBigWeight: 'tooBigWeight',
  smallSize: 'smallSize',
  onModeration: 'onModeration',
  faceNotFound: 'face_not_found',
  multipleFacesFound: 'multiple_faces_found',
  smallImage: 'small_image',
  imageNotFound: 'image_not_found',
  uploadImage: 'uploadImage',
  notNetwork: 'notNetwork',
  other: 'other',
} as const

export type AvatarEditorAlert = {
  title: string
  text: string
}

export const AVATAR_ERROR_MESSAGES: Record<string, AvatarEditorAlert> = {
  [AVATAR_ERROR_TYPE.unsupportedFormat]: {
    title: 'Формат не поддерживается',
    text: 'Файл должен быть в формате PNG, JPEG, WEBP.',
  },
  [AVATAR_ERROR_TYPE.smallSize]: {
    title: 'Фотография слишком маленькая',
    text: 'Загрузите фотографию, где ваше лицо различимо.',
  },
  [AVATAR_ERROR_TYPE.tooBigWeight]: {
    title: 'Слишком большой файл',
    text: `Загрузите файл до ${MAX_AVATAR_FILE_SIZE_MB} Мб.`,
  },
  [AVATAR_ERROR_TYPE.smallImage]: {
    title: 'Фотография слишком маленькая',
    text: 'Загрузите фотографию, где ваше лицо различимо.',
  },
  [AVATAR_ERROR_TYPE.faceNotFound]: {
    title: 'Похоже, вас нет на фотографии',
    text: 'Загрузите фотографию, где есть ваше лицо.',
  },
  [AVATAR_ERROR_TYPE.multipleFacesFound]: {
    title: 'На фотографии больше одного человека',
    text: 'Загрузите фотографию, где есть только вы.',
  },
  [AVATAR_ERROR_TYPE.uploadImage]: {
    title: 'Не получилось загрузить фото',
    text: 'Обновите страницу и попробуйте ещё раз.',
  },
  [AVATAR_ERROR_TYPE.notNetwork]: {
    title: 'Нет соединения с интернетом',
    text: 'Проверьте соединение, обновите страницу и попробуйте ещё раз.',
  },
  [AVATAR_ERROR_TYPE.onModeration]: {
    title: 'Не получилось загрузить фото',
    text: 'Клиника загрузила фото, которое находится на модерации. Пока изображение находится на модерации нельзя загрузить новое',
  },
  [AVATAR_ERROR_TYPE.other]: {
    title: 'Произошла ошибка',
    text: '',
  },
}
